import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { io } from 'socket.io-client';
import { fetchPaymentLinks, fetchGuestById } from '../../Service';
import { TextField, Button, Radio, RadioGroup, Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid2';
import { styled } from '@mui/system';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';


const API_URL = process.env.REACT_APP_API_URL;

const Pamphlet = () => {

    return (
        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh' }}>
            <Grid item xs={12} sm={12} md={6}>
                <Card variant="outlined" className="login-card"> 
                    <CardContent>
                        <Typography variant="h5" gutterBottom>ようこそ</Typography>
                


                    </CardContent>
                </Card>
            </Grid>                   
        </Grid>
    );
};

export default Pamphlet;
